<template>
  <div class="charge-warp" v-loading="loading">
    <div class="display-f just-b align-i-c">
      <el-form ref="form" :model="searchForm" inline>
        <el-form-item label="就诊日期：">
          <el-date-picker value-format="yyyy-MM-dd" v-model="searchForm.date" type="daterange" @change="timeChange"
            :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="接待人：">
          <el-select v-model="searchForm.salesPersonCode" placeholder="请选择接待人" filterable>
            <el-option v-for="item in userOptions" :key="item.userCode" :label="item.nickName" :value="item.userCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医馆：" v-if="[0,-1].includes(deptId)">
          <el-select v-model="searchForm.deptId" placeholder="医馆" clearable>
            <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <custom-button type="primary" @click="handleSearch">查询</custom-button>
          <custom-button type="" @click="handleReset">重置</custom-button>
        </el-form-item>
      </el-form>
      <custom-button type="primary" plain @click="handleExport">导出</custom-button>
    </div>
    <div class="table-warp">
      <el-table :data="tableData" :cell-style="{ borderColor: '#DDDDDD' }" style="width: 100%" border height="650px"
        :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }">
        <el-table-column prop="date" label="日期" width="135" fixed></el-table-column>
        <el-table-column prop="salesPerson" label="接待人" width="100" fixed></el-table-column>
        <el-table-column prop="deptName" label="医馆" width="100" fixed></el-table-column>
        <el-table-column prop="orderFinishPersonCount" label="就诊人数" width="100"></el-table-column>
        <el-table-column prop="orderFinishCount" label="就诊人次" width="100"></el-table-column>
        <el-table-column prop="payPersonCount" label="交费人数" width="100"></el-table-column>
        <el-table-column prop="payCount" label="交费人次" width="100"></el-table-column>
        <el-table-column prop="totalOrderAmount" label="开单金额合计" width="120"></el-table-column>
        <el-table-column prop="totalPayAmount" label="交费金额合计" width="120"></el-table-column>
        <el-table-column prop="totalYlOrderAmount" label="医联产品开单金额合计" width="170"></el-table-column>
        <el-table-column prop="totalYlPayAmount" label="医联产品交费金额合计" width="170"></el-table-column>
        <el-table-column prop="orderAmountPer" label="人均开单金额" width="120"></el-table-column>
        <el-table-column label="中药饮片（普通）">
          <el-table-column prop="piece" label="开单"></el-table-column>
          <el-table-column prop="piecePay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="中药饮片（医联）">
          <el-table-column prop="pieceYl" label="开单"></el-table-column>
          <el-table-column prop="pieceYlPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="中药颗粒（普通）">
          <el-table-column prop="particle" label="开单"></el-table-column>
          <el-table-column prop="particlePay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="中药颗粒（医联）">
          <el-table-column prop="particleYl" label="开单"></el-table-column>
          <el-table-column prop="particleYlPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="中成药">
          <el-table-column prop="chinesePatentDrug" label="开单"></el-table-column>
          <el-table-column prop="chinesePatentDrugPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="理疗项目">
          <el-table-column prop="physio" label="开单"></el-table-column>
          <el-table-column prop="physioPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="加工-熬药">
          <el-table-column prop="decoctHerbs" label="开单"></el-table-column>
          <el-table-column prop="decoctHerbsPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="加工-制膏">
          <el-table-column prop="creamMaking" label="开单"></el-table-column>
          <el-table-column prop="creamMakingPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="加工-制丸">
          <el-table-column prop="pill" label="开单"></el-table-column>
          <el-table-column prop="pillPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="加工-打粉">
          <el-table-column prop="powder" label="开单"></el-table-column>
          <el-table-column prop="powderPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="加工-加工YL">
          <el-table-column prop="combo" label="开单"></el-table-column>
          <el-table-column prop="comboPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="快递费">
          <el-table-column prop="deliveryPrice" label="开单"></el-table-column>
          <el-table-column prop="deliveryPricePay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="医疗器械">
          <el-table-column prop="medicalDevice" label="开单"></el-table-column>
          <el-table-column prop="medicalDevicePay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="后勤材料">
          <el-table-column prop="logisticsMaterial" label="开单"></el-table-column>
          <el-table-column prop="logisticsMaterialPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="保健食品">
          <el-table-column prop="healthFood" label="开单"></el-table-column>
          <el-table-column prop="healthFoodPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="其他商品">
          <el-table-column prop="otherGoods" label="开单"></el-table-column>
          <el-table-column prop="otherGoodsPay" label="交费"></el-table-column>
        </el-table-column>
        <el-table-column label="未分类">
          <el-table-column prop="notClassified" label="开单"></el-table-column>
          <el-table-column prop="notClassifiedPay" label="交费"></el-table-column>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="searchForm.pageNum" :page-sizes="[15, 30, 50, 100]" background :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import customTable from '@/components/customTable/customTable'
import { statementDTO, CommonDTO, deptDTO } from '@/DTO/index'
import { userList } from "@/api/user"; // 用户请求
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { isMoreThanOneYear, debounce, isEmptyArray } from '@/utils/validateBase'
import { isNull } from '../../../../utils/validateBase';
export default {
  // 定义引入的组件
  components: { customTable },
  props: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨日',
          onClick(picker) {
            let yesterday = moment().subtract(1, 'days')
            const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '本周',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '本月',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        {
          text: '本年',
          onClick(picker) {
            const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
            const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end]);
          }
        },
        ]
      },
      searchForm: {
        date: [],
        salesPersonCode: '',
        pageNum: 1,
        pageSize: 15,
        deptId:''
      },//搜索条件
      tableData: [],//表格数据
      total: 0,//总数
      sum: [],//总计
      loading: false,
      userOptions: [],//接待人列表
      deptList: [],//医馆列表
      deptId: this.$session.get('deptId')
    }
  },
  //变量监听
  watch: {},
  filters: {
    filterSigned(row) {
      return Utils.bigNumber(row.row.staySeeNum, '+', row.row.alreadySeeNum)
    },
    filterSignedAmount(row) {
      return Utils.bigNumber(row.row.staySeeAmount, '+', row.row.alreadySeeAmount)
    },
  },
  // 页面初始化
  async created() {
    this.getUserOption()
    this.getDeptList()
    let time = CommonDTO.getSystemTimeDTO()
    let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
    let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
    this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
    this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
    this.searchForm.deptId = [0,-1].includes(deptId) ? '' : this.deptId
    this.getData()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    //获取所有医馆
    async getDeptList() {
      let deptId = this.$session.get('deptId')
      if (![0,-1].includes(deptId)) return
      this.deptList = await deptDTO.getDeptList()
    },
    //获取接待人列表
    async getUserOption() {
      let { code, rows } = await userList({ deptId: [] });
      if (code == 200) this.userOptions = rows;
    },
    /**
     * 重置
     */
    handleReset() {
      this.searchForm = {
        date: [],
        salesPersonCode: '',
        pageNum: 1,
        pageSize: 15
      }
      this.searchForm.deptId = [0,-1].includes(deptId) ? '' : this.deptId
      let startOfDay = Number(Utils.startOfDay(this.$moment()))
      let endOfDay = Number(Utils.endOfDay(this.$moment()))
      this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
      this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
      this.getData()
    },

    /**
     * 搜索
     */
    handleSearch: debounce(async function () {
      this.searchForm.pageNum = 1
      let flag = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
      if (flag) return this.$message.error('时间范围不能超过一年')
      // let HH = this.$moment().get('hour')
      // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0],  this.searchForm.date[1], 1)
      // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
      this.getData()
    }, 1000, true),
    /**
     * 获取分页、统计数据
     */
    async getData() {
      this.searchForm.startTime = Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
      this.searchForm.stopTime = Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
      this.getSalesPerformanceReportPage();
    },

    /**
     * 查询接待人业绩
     */
    async getSalesPerformanceReportPage() {
      this.loading = true
      this.tableData = []
      let { code, data, total } = await statementDTO.getSalesPerformanceReportPage(this.searchForm)
      if (code == 200 && !isNull(data)) {
        this.loading = false
        this.tableData = this.searchForm.pageNum == 1 ? data.list : [...this.tableData, ...data.list]
        this.total = total
        this.tableData.push({ date: '合计', ...data.salesPerformanceReportSumCount })
      } else {
        this.loading = false
      }
    },
    /**
    * 导出
    */
    handleExport: debounce(function () {
      this.searchForm.startTime = Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
      this.searchForm.stopTime = Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
      statementDTO.salesExport(this.searchForm, { name: '接待业绩' }).then(res => { })
    }, 1000, true),
    /**
     * 时间选择器改变
     */
    timeChange(val) {
      val[0] = Utils.timeFormat(Number(Utils.startOfDay(val[0])), 'yyyy-MM-DD HH:mm:ss')
      val[1] = Utils.timeFormat(Number(Utils.endOfDay(val[1])), 'yyyy-MM-DD HH:mm:ss')
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val;
      this.getData()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNum = val
      this.getData()
    }
  },
}
</script>
<style lang="less" scoped>
.charge-warp {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .el-form-item {
    margin-bottom: 0;
  }

  .table-warp {
    margin-top: 16px;
    flex: 1;
    overflow: auto;
    /deep/.el-table {
      border-color: #DDDDDD;
      height: 100%;
      overflow: auto;
    }

    /deep/.pagination-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 0;

      .total-tips {
        color: #667182;
        font-size: 14px;
      }
    }

    /deep/.el-table__row {
      &:last-child {
        font-weight: bold;
      }
    }
  }

  .page {
    margin: 10px;
    text-align: right;
  }
}
</style>